'use client';

/*
 * Landing page shell.
 *
 * The actual content lives in `./_HomePageContent` and is dynamically
 * imported with `ssr: false`. This is intentional:
 *
 *   1. The content is heavily interactive (live KPIs, animated charts,
 *      ROI calculator, IntersectionObserver-driven reveals) and was
 *      causing repeated React hydration mismatches that the browser
 *      reported as "unrecoverable error" full reloads.
 *   2. Loading the content as its own client-only chunk also gives it
 *      a stable module identity across Fast Refresh, fixing the
 *      `ReferenceError: Field is not defined at RoiCalculator` crash
 *      that came from a stale split-bundle holding a renamed local
 *      `RoiField` component.
 */
import dynamic from 'next/dynamic';

const HomePageContent = dynamic(() => import('./_HomePageContent'), {
  ssr: false,
});

export default function HomePage() {
  return <HomePageContent />;
}
